import { RootState } from '@/app/store/type';
import { createSelector } from '@reduxjs/toolkit';

export const selectContentState = (state: RootState) => state.content;
export const selectContentLoading = (state: RootState) =>
  state.content.isLoading;
export const selectContentError = (state: RootState) => state.content.error;

export const selectFooterData = (state: RootState) =>
  state.content.data?.footer;
export const selectContacts = (state: RootState) =>
  state.content.data?.contacts;
export const selectHomePage = (state: RootState) =>
  state.content.data?.homePage;
export const selectBuildingCategories = (state: RootState) =>
  state.content.data?.homePage?.company?.directions ?? null;
export const selectBuildingCategoryById = (id: string) =>
  createSelector([selectBuildingCategories], (categories) => {
    return (categories ?? []).find((category) => category.id === id);
  });
